import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { completeGoogle } = useAuth();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(match[1]);
    completeGoogle(sessionId)
      .then((u) => {
        window.history.replaceState(null, "", "/app");
        toast.success("Connexion réussie");
        navigate(u?.role === "admin" || u?.role === "agent" ? "/app/admin" : "/app", { replace: true });
      })
      .catch(() => {
        toast.error("Connexion Google échouée");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50">
      <div className="h-10 w-10 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin" />
      <p className="mt-4 text-sm text-slate-500">Connexion en cours...</p>
    </div>
  );
}
